
function userPath(userId) {
  return `users/${userId}`;
}

// eslint-disable-next-line import/prefer-default-export
export function getUserProfilesPath(userId) {
  return `${userPath(userId)}/profiles`;
}
